import { patientAction } from '../../actions/constant';

const { GET_PATIENT_FAILURE, GET_PATIENT_SUCCESS, GET_PATIENT_LOADING } = patientAction;

const intitialstate: object = {
  response: null,
  isError: false,
  errorMessage: '',
  loading: false,
};

export const getPatientReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_PATIENT_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };
    }

    case GET_PATIENT_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };

    case GET_PATIENT_LOADING:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
